import { ExchangeActionEnum } from "@b2bportal/air-exchange-api";
import { keyBy } from "lodash-es";
import type { FlightState } from "../../../store/slice";
import { FlightPostBookingSelectors } from "../../postbooking/store";
import { FlightShopSelectors } from "../../shop/store";

import { selectedTripSelector } from "../../shop/store/selectors/selectors";
import { getOutboundSelection, getReturnSelection } from "./searchSelectors";

export const getOutboundSlice = (state: FlightState) => {
  const itinerary =
    FlightPostBookingSelectors.getSelectedFlightItinerary(state);
  const outboundSelection = getOutboundSelection(state);
  const shoppedTrip = selectedTripSelector(state);
  const flights = FlightShopSelectors.getFlightsData(state);
  const { outgoingSliceId } = shoppedTrip;

  if (outboundSelection === ExchangeActionEnum.Keep && itinerary.data != null) {
    return FlightPostBookingSelectors.getDepartureSlice(
      itinerary.data.bookedItinerary
    );
  } else if (flights != null && outgoingSliceId != null) {
    return flights.slices[outgoingSliceId];
  }

  return null;
};

export const getReturnSlice = (state: FlightState) => {
  const itinerary =
    FlightPostBookingSelectors.getSelectedFlightItinerary(state);
  const returnSelection = getReturnSelection(state);
  const shoppedTrip = selectedTripSelector(state);
  const flights = FlightShopSelectors.getFlightsData(state);
  const { returnSliceId } = shoppedTrip;

  if (returnSelection === ExchangeActionEnum.Keep && itinerary.data != null) {
    return FlightPostBookingSelectors.getReturnSlice(
      itinerary.data.bookedItinerary
    );
  } else if (flights != null && returnSliceId != null) {
    return flights.slices[returnSliceId];
  }

  return null;
};

export const getShoppedPaxPricingMap = (state: FlightState) => {
  const tripDetails = FlightShopSelectors.getSelectedTripDetails(state);
  const paxPricing = tripDetails?.fareDetails[0].paxPricings;

  return keyBy(paxPricing, "paxType");
};
